export default __webpack_public_path__ + "static/fs3-a803b8dc45edf355de7f033ba1104e64.png";